<!--
   Created by qing on 2020/8/19
   Des: 企业微信进入的首页
-->
<template>
	<div
		class="home-container"
		v-wechat-title="$route.meta.title"
	>
		<div class="home-sub-container">
			<router-view />
		</div>
		<van-tabbar
			route
			active-color="#4260FA"
		>
			<van-tabbar-item
				v-for="item in pageList"
				:key="item.name"
				replace
				:to="item.route"
				:icon="item.icon"
			>
				{{item.name}}
				<template #icon="props">
					<img :src="props.active ? item.activeIcon : item.inactiveIcon" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pageList: [{
						route: '/home/workStation',
						activeIcon: require('../../../assets/images/workdeskB.png'),
						inactiveIcon:require('../../../assets/images/workdeskG.png'),
						name: '工作台'
					},
					{
						route: '/home/mix_form',
						activeIcon: require('../../../assets/images/projectB.png'),
						inactiveIcon:require('../../../assets/images/projectG.png'),
						name: this.$store.getters.mix_form_name
					},
					{
						route: '/home/apps',
						activeIcon: require('../../../assets/images/applyB.png'),
						inactiveIcon:require('../../../assets/images/applyG.png'),
						name: '应用'
					},
					{
						route: '/home/mine',
						activeIcon: require('../../../assets/images/mineB.png'),
						inactiveIcon:require('../../../assets/images/mineG.png'),
						name: '更多'
					}
				],

				levelInfo: null
				/*
				* {
				  "adminFlag":1, //是否是超管 0 否 1 是
				  "levelName":"基础版",
				  "remindType":"OVERTIME", //NONE 不提醒 REMIND 即将超期 OVERTIME 已超期
				  "tryFlag":0, //是否是试用 0 否 1 是
				  "remainDays":1 //剩余几天时间
				}
				* */
			}
		},
		created() {
			console.log('home- $store -', this.$store)
			console.log('home- userId -', this.$store.getters.userId)
			this.$store.dispatch('actionLevelCheck')
				.then(res => {
					this.levelInfo = res || {}

					if (this.levelInfo.remindType === 'REMIND') {
						// 即将超期 给超管提醒
						if (this.levelInfo.adminFlag) {
							let levelNum = localStorage.getItem(`level_${this.$store.getters.currentCompanyId}`)
							localStorage.setItem(`level_${this.$store.getters.currentCompanyId}`, this.levelInfo
								.remainDays)

							if (levelNum) {
								levelNum = Number(levelNum)
								if (this.levelInfo.remainDays <= 31 && this.levelInfo.remainDays >= 15) {
									if (!(levelNum <= 31 && levelNum >= 15)) {
										this.showDialog()
									}
								} else if (this.levelInfo.remainDays < 15 && this.levelInfo.remainDays >= 7) {
									if (!(levelNum < 15 && levelNum >= 7)) {
										this.showDialog()
									}
								} else if (this.levelInfo.remainDays < 7 && this.levelInfo.remainDays >= 4) {
									if (!(levelNum < 7 && levelNum >= 4) && !this.levelInfo.tryFlag) {
										this.showDialog()
									}
								} else if (this.levelInfo.remainDays === 3) {
									if (levelNum !== 3) {
										this.showDialog()
									}
								} else if (this.levelInfo.remainDays === 2) {
									if (levelNum !== 2) {
										this.showDialog()
									}
								} else if (this.levelInfo.remainDays === 1) {
									if (levelNum !== 1) {
										this.showDialog()
									}
								}

							} else {
								if (this.levelInfo.remainDays <= 7 && this.levelInfo.remainDays >= 4) {

									if (!this.levelInfo.tryFlag) {
										this.showDialog()
									}

								} else {
									this.showDialog()
								}
							}

						}

					} else if (this.levelInfo.remindType === 'OVERTIME') {
						// 已超期 给全员提醒
						let level_overtime = localStorage.getItem(
							`level_overtime_${this.$store.getters.currentCompanyId}`)

						if (level_overtime) {
							const timestamp = new Date(level_overtime).getTime()
							if (new Date().getTime() - timestamp > 86400000) {
								localStorage.setItem(`level_overtime_${this.$store.getters.currentCompanyId}`,
									new Date())
								this.showDialog()
							}
						} else {
							localStorage.setItem(`level_overtime_${this.$store.getters.currentCompanyId}`, new Date())
							this.showDialog()
						}
					}

				}).catch(console.error)
			this.$store.dispatch('setPageTitle', this.$route.meta.title)
		},
		methods: {

			showDialog() {
				let title = ''
				let message = ''
				if (this.levelInfo.remindType === 'REMIND') {
					title = '版本授权即将到期'
					message = `版本授权还有${this.levelInfo.remainDays}天过期，请及时续费, 详情请在电脑端查看`
				} else {
					title = '版本授权已过期'
					if (this.levelInfo.adminFlag) {
						message = '版本授权已到期，请续费后使用, 详情请在电脑端查看。'
					} else {
						message = '版本授权已到期，请联系团队管理员续费。'
					}
				}
				this.$dialog.confirm({
					title,
					message,
					confirmButtonText: '知道了',
					showCancelButton: false
				}).then(() => {

				}).catch(action => {})
			}
		}
	}
</script>

<style lang="less">
	.home-container {
		height: calc(100% - env(safe-area-inset-bottom));

		.home-sub-container {
			height: calc(100% - 50px);
		}
	}
</style>
